module.exports = __webpack_public_path__ + "static/conference-2026-2500-0350929b399b3c5008db7f9e255b5ac1.webp";